<nav class="navbar navbar-expand-lg navbar-inverse bg-inverse d-flex justify-content-start p-4">
    <div class="navbar-header d-flex flex-column">
      <span class="title p-0 mb-0 font-weight-light text-truncate">{{title}}</span>
      <span class="name p-0 mb-0 text-truncate">{{file?.displayName}}</span>
    </div>
    <div class="navbar-nav content ml-auto">
        <ng-content *ngIf="!hideOptions"></ng-content>
        <a class="nav-link" (click)="backClicked()"><span><i class="icon icon-btn-close float-sm-right float-md-right" aria-hidden="true"></i></span></a>
    </div>
</nav>

